module.exports = __webpack_public_path__ + "img/Honigloeffel-v1-800.a26d898b.png";